<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="state"
                :options="filteredStates"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <color-picker
                v-if="!state"
                :value="color"
                @input="onInput"
            />

            <color-picker
                v-if="state === 'hover'"
                :value="hoverColor"
                @input="onInput"
            />

            <color-picker
                v-if="state === 'selected'"
                :value="selectedColor"
                @input="onInput"
            />

            <color-picker
                v-if="state === 'expanded'"
                :value="expandedColor"
                @input="onInput"
            />

            <color-picker
                v-if="state === 'matching'"
                :value="matchingColor"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import colorData from '@/data/constants/colors';

export default {
    name: 'background-color',
    mixins: [baseOption],

    data() {
        return {
            color: '',
            hoverColor: '',
            selectedColor: '',
            expandedColor: '',
            matchingColor: '',

            state: '',
            stateOptions: [
                {
                    text: 'Default',
                    value: '',
                },
                {
                    text: 'Hover',
                    value: 'hover',
                },
                {
                    text: 'Selected',
                    value: 'selected',
                    displayFor: ['a-text-single-line', 'links-nav', 'nav-dropdown', 'tab-container'],
                },
                {
                    text: 'Expanded',
                    value: 'expanded',
                    displayFor: ['hamburger-button'],
                },
                {
                    text: 'Matching',
                    value: 'matching',
                    displayFor: ['a-link', 'nav-dropdown'],
                },
            ],
            tailwindDefinitionProp: 'backgroundColor',
        };
    },

    computed: {
        displayName() {
            // temp workaround until a proper custom labeling solution is implemented
            return this.selectedElements[0].elementTypeNew === 'hamburger-button' ? 'Color' : 'Background Color';
        },

        filteredStates() {
            const { elementTypeNew } = this.selectedElements[0];

            return this.stateOptions.filter((state) => {
                if (state.displayFor) {
                    return state.displayFor.includes(elementTypeNew);
                }

                return true;
            });
        },
    },

    methods: {
        onInput(color) {
            const localColorProp = this.state ? `${ this.state }Color` : 'color';

            if (color === colorData.NO_COLOR_FLAG) {
                this[localColorProp] = '';
                this.removeFlexClass(this.state);
                this.onOptionChange();
                return;
            }

            const flexClassNew = this.addFlexClass({
                value: color,
                state: this.state,
                screen: this.state ? 'all' : this.screen,
            });

            this[localColorProp] = color;
            this.onOptionChange(flexClassNew);
        },

        onStateInput(newState) {
            this.state = newState;
            this.setDefaultColor();
        },

        onSelectedElement() {
            this.state = this.flexClassDefinition.state || '';
            this.setDefaultColor();
        },
    },
};
</script>
